module.exports = __webpack_public_path__ + "img/careclub.a92cb14f.svg";